function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.825 21.627a2.016 2.016 0 11-4.033 0 2.016 2.016 0 014.033 0z",
  fill: "#FFCE32"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.908 31.496h5.305v-7.64l5.518-2.335 5.73 2.122v7.799h26.104v7.057H2.908v-7.003z",
  fill: "#F8FBCF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.886 40.834H46.2V7.153H1.886v33.68z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#labelless_svg__a)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.699 27.251h2.122V25.13H9.699v2.122zM9.699 31.071h2.122V28.95H9.699v2.122z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.908 40.834h42.869v-4.67H2.907v4.67z",
  fill: "#F2F4F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.836 34.9h17.857V16.429H27.836V34.9zM27.836 35.14V20.55h-6.343l-3.013 5.868-4.987 2.381v6.341h14.343z",
  fill: "#FFCE32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.645 35.24h33.556v-2.712H12.645v2.712z",
  fill: "#406367"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.224 26.418h6.344v-4.916h-3.965l-2.379 4.916z",
  fill: "#D2B982"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.348 28.797h2.378v-.951h-2.378v.951zM25.17 21.502l-1.774 4.916h-3.33l2.379-4.916h2.725z",
  fill: "#F8FBCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.988 28.085l-1.495 2.748v-2.034l1.495-.714z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.729 16.428l17.868 16.1H27.73v-16.1z",
  fill: "#F8FBCF"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.723 31.442h6.86v6.86h-6.86v-6.86z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#labelless_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.714 31.76a3.43 3.43 0 102.878 6.225 3.43 3.43 0 00-2.878-6.226z",
  fill: "#002F34"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.603 33.681a1.312 1.312 0 11-.64 1.742 1.314 1.314 0 01.64-1.742z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.907 31.442h6.861v6.86h-6.86v-6.86z",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#labelless_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.898 31.76a3.43 3.43 0 102.878 6.226 3.43 3.43 0 00-2.877-6.227z",
  fill: "#002F34"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.787 33.681a1.312 1.312 0 111.102 2.382 1.312 1.312 0 01-1.102-2.382z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.735 15.791a1.592 1.592 0 00-2.261-1.745 2.862 2.862 0 00-5.302.931 1.053 1.053 0 00-.258-.035c-.513 0-.94.365-1.04.849h8.86z",
  fill: "#CEDDFF"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.252 10.91c.023-.118.036-.357.036-.482a1.82 1.82 0 00-2.621-1.631 3.272 3.272 0 00-6.06 1.065 1.21 1.21 0 00-.296-.04c-.587 0-1.076.534-1.188 1.088h10.129z",
  fill: "#3A77FF"
});

const SvgLabelless = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  fill: "none"
}, props), _ref, _ref2, /*#__PURE__*/React.createElement("mask", {
  id: "labelless_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 1,
  y: 7,
  width: 46,
  height: 34
}, _ref3), _ref4, /*#__PURE__*/React.createElement("mask", {
  id: "labelless_svg__b",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 14,
  y: 31,
  width: 8,
  height: 8
}, _ref5), _ref6, _ref7, /*#__PURE__*/React.createElement("mask", {
  id: "labelless_svg__c",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 35,
  y: 31,
  width: 8,
  height: 8
}, _ref8), _ref9, _ref10, _ref11, _ref12);

export default SvgLabelless;